import { Box, makeStyles, styled } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: theme.palette.text.secondary,
  },
}));

export const StyledBoxHeader = styled(Box)({
  // override css for Header
  '&': {
    zIndex: 100,
    position: 'relative',
    gridArea: 'pageHeader',
    '& > header': {
      paddingLeft: 42,
      paddingRight: 42,
    },
  },
});

export default useStyles;
